module.exports = __webpack_public_path__ + "static/media/Nidoran♂_gaussian2.bb0b0af9.png";